import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const GarrisonDamageService = {
    getAllVehicles: async () => axios.get(`${API_URL}/garrison_damage/vehicles/getAllVehicles`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default GarrisonDamageService;